import React, { useState, useEffect } from "react";
import Step1SelectPatient from "./Step1SelectPatient";
import Step2SelectContent from "./Step2SelectContent";
import Step3Schedule from "./Step3Schedule";
import Step4Confirmation from "./Step4Confirmation";
//import "./Styles.css";

const DigimevoPrescription = () => {
    const [step, setStep] = useState(1);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [selectedContent, setSelectedContent] = useState(null);
    const [scheduleOption, setScheduleOption] = useState(null);
    const [patients, setPatients] = useState([]);

    useEffect(() => {
        const fetchPatients = async () => {
            try {
                const response = await fetch(
                    "https://apipro.intern.saludti.es/users/patients/byDoctor/67ea2e7d7f31d2c7e51ba12f"
                );
                const data = await response.json();
                console.log("Pacientes recibidos:", data);

                // 🔧 Aquí construimos fullName para que Step1 lo pueda usar
                const normalized = (data.data || []).map(p => ({
                    ...p,
                    fullName: `${p.name} ${p.surname}`.trim()
                }));

                setPatients(normalized);
            } catch (error) {
                console.error("Error al cargar pacientes:", error);
            }
        };

        fetchPatients();
    }, []);

    const goToStep = (n) => {
        setStep(n);
        window.scrollTo(0, 0);
    };

    return (
        <div className="app-container">
            <header className="app-header">
                <button className="back-button" onClick={() => goToStep(Math.max(1, step - 1))}>
                    ←
                </button>
                <h1>Prescripción de Contenido</h1>
                <div></div>
            </header>

            {step === 1 && (
                <Step1SelectPatient
                    patients={patients}
                    selectedPatient={selectedPatient}
                    setSelectedPatient={setSelectedPatient}
                    goToStep={goToStep}
                />
            )}

            {step === 2 && (
                <Step2SelectContent
                    selectedPatient={selectedPatient}
                    selectedContent={selectedContent}
                    setSelectedContent={setSelectedContent}
                    goToStep={goToStep}
                />
            )}

            {step === 3 && (
                <Step3Schedule
                    selectedPatient={selectedPatient}
                    selectedContent={selectedContent}
                    scheduleOption={scheduleOption}
                    setScheduleOption={setScheduleOption}
                    goToStep={goToStep}
                />
            )}

            {step === 4 && (
                <Step4Confirmation
                    patient={selectedPatient}
                    video={selectedContent}
                    schedule={scheduleOption}
                    restart={() => {
                        setSelectedPatient(null);
                        setSelectedContent(null);
                        setScheduleOption(null);
                        setStep(1);
                    }}
                />
            )}
        </div>
    );
};

export default DigimevoPrescription;
